// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22.5 2H1.5V22.7038L6.87574 18H22.5V2ZM8.28788 6.55546C9.30471 5.53862 10.9197 5.48455 12.0002 6.39325C13.0806 5.48455 14.6957 5.53862 15.7125 6.55546C16.7864 7.6294 16.7864 9.3706 15.7125 10.4445L12.0002 14.1569L8.28788 10.4445C7.21394 9.3706 7.21394 7.6294 8.28788 6.55546Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-chat-heart-filled')
export default class ChatHeartFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chat-heart-filled',
    }
  }
}
